import { GivelifyTextDivider } from '@givelify/givelify-ui';
import {
    GivelifyBreadcrumbs,
    GivelifyButton,
    GivelifyLabel,
    GivelifyPaper,
} from '@givelify/ui';
import { styled } from '@mui/material';
import { SMGivingTip } from '../../../components/SMGivingTip';

export const Container = styled(GivelifyPaper)(({ theme }) => ({
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down('mobile')]: {
        padding: theme.spacing(4, 2),
    },
}));

export const TipContainer = styled(SMGivingTip)({
    marginTop: '40px',
});

export const ShareButton = styled(GivelifyButton)(({ theme }) => ({
    '& > img': {
        marginRight: theme.spacing(1),
    },
    [theme.breakpoints.down('mobile')]: {
        width: '100%',
    },
}));

export const Divider = styled(GivelifyTextDivider)({
    margin: '20px 0',
});

export const PreviewContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('mobile')]: {
        justifyContent: 'center',
        textAlign: 'center',
    },
}));

export const HideOnMobile = styled('div')(({ theme }) => ({
    display: 'initial',
    [theme.breakpoints.down('mobile')]: {
        display: 'none',
    },
}));

export const PreviewImage = styled('img')({
    maxWidth: '381px',
    width: '100%',
    height: 'auto',
});

export const PreviewArrowsContainer = styled('div')(({ theme }) => ({
    position: 'relative',
}));

export const PreviewTitle = styled(GivelifyLabel)({
    margin: '24px 0 6px 0',
    color: '#676E77',
});

export const ImgArrowText = styled(GivelifyLabel)({
    marginLeft: 'calc(227px - 81px)',
    marginTop: '-10px',
    textAlign: 'center',
    width: '115px',
    color: '#676E77',
});

export const LinkArrow = styled('img')({
    marginLeft: 'calc(333px - 81px)',
});

export const Breadcrumbs = styled(GivelifyBreadcrumbs)(({ theme }) => ({
    '& .separator': {
        margin: theme.spacing(0, 1),
    },
    marginBottom: theme.spacing(3),
}));
